import React from "react";

const TextAreaField = ({ name, label, sublabel, placeholder, value, onChange, inputType, error, rows, cols, inputStyle }) => {
  return (
    <div className="d-flex flex-column mb-2">
      <span className="text-black fs-normal">{label}</span>
      {sublabel && <span className="text-grey1 fs-sm">{sublabel}</span>}
      <textarea className="bg-grey2 border-0 outline-0 px-2 py-2 rounded fs-md text-black fw-medium" name={name} value={value} type={inputType || "text"} onChange={onChange} placeholder={placeholder ?? "Enter text..."} style={inputStyle} rows={rows} cols={cols}>
        {value}
      </textarea>
      <span className="text-danger fs-sm">{error || ""}</span>
    </div>
  );
};

export default TextAreaField;
